var map = {
	"./Arrow-accent-right.svg": "4a7f",
	"./Arrow-right-alt.svg": "b75a",
	"./Arrow-right.svg": "7807",
	"./Attach-File.svg": "bb00",
	"./Attention.svg": "3846",
	"./Badge-verified.svg": "2129",
	"./Bell-solid.svg": "2dfa",
	"./Bell.svg": "37b8",
	"./Camera.svg": "b617",
	"./Cash.svg": "db72",
	"./Catalog.svg": "ca40",
	"./Check.svg": "d419",
	"./CheckNew.svg": "ba2b",
	"./Chevron-left.svg": "f013",
	"./Clock.svg": "8e6f",
	"./Comments.svg": "242c",
	"./CreateDeal.svg": "1fa8",
	"./Credit-Card-MasterCard.svg": "0cb2",
	"./Credit-Card-Paypal.svg": "40e6",
	"./Credit-Card-Visa.svg": "d87b",
	"./Cursor-Pointer.svg": "5f36",
	"./Danger.svg": "94ef",
	"./Dashboard.svg": "8ae4",
	"./Deals-2.svg": "c81d",
	"./Deals-accent.svg": "12f4",
	"./Deals.svg": "104e",
	"./Feedback-dark.svg": "3d55",
	"./Feedback.svg": "a40f",
	"./File-signature.svg": "928b",
	"./Fingerprint.svg": "5b50",
	"./Flag.svg": "2c53",
	"./Globe.svg": "e438",
	"./Hand-holding-dollar.svg": "946e",
	"./Logout.svg": "3a84",
	"./Modal-Close-Dark.svg": "5bc8",
	"./Modal-Close.svg": "5c2a",
	"./Pen.svg": "5b78",
	"./PenNew.svg": "7f73",
	"./Plus-Accent.svg": "6a6f",
	"./Plus.svg": "6f54",
	"./Search.svg": "8196",
	"./Settings.svg": "2ddc",
	"./Sign.svg": "d9de",
	"./Social-facebook-accent.svg": "d54e",
	"./Social-instagram-accent.svg": "5f59",
	"./Social-instagram.svg": "2e22",
	"./Social-itunes.svg": "5c52",
	"./Social-round-facebook.svg": "33d1",
	"./Social-round-instagram.svg": "4628",
	"./Social-round-twitter.svg": "0d44",
	"./Social-spotify.svg": "69ab",
	"./Social-twitter.svg": "d9cd",
	"./Social-youtube.svg": "a67e",
	"./Sptest.svg": "e3c7",
	"./Support.svg": "5dcb",
	"./Switch.svg": "bcae",
	"./Track-Download.svg": "0dd5",
	"./Track-Note.svg": "5e70",
	"./Track-Pause.svg": "a3b3",
	"./Track-Play.svg": "320b",
	"./Track-Spotify.svg": "9b47",
	"./Upload-Cloud.svg": "fec5",
	"./Upload-Cloud2.svg": "ea60",
	"./User-solid.svg": "5c8c",
	"./User.svg": "99e4",
	"./Wallet.svg": "6fa4",
	"./instagram-color.svg": "e0d6",
	"./instagram.svg": "bd6c",
	"./itunes-color.svg": "58e2",
	"./itunes.svg": "8963",
	"./mastercard.svg": "8302",
	"./pink-facebook.svg": "5771",
	"./pink-instagram.svg": "7771",
	"./pink-twitter.svg": "0d3c",
	"./spotify.svg": "86ec",
	"./twitter.svg": "acf9",
	"./visa.svg": "30e2",
	"./youtube.svg": "11ef",
	"./youtube2.svg": "833c",
	"./youtube3.svg": "ad44",
	"./youtube4.svg": "4189",
	"./youtube5.svg": "8ad8"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6f32";